/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_BathroomsInputs */

const en_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bathrooms`)
};

const es_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baños`)
};

const fr_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salles de bain`)
};

const de_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Badezimmer`)
};

const ja_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バスルーム数`)
};

const zh_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浴室`)
};

const ar_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دورات المياه`)
};

const id_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamar Mandi`)
};

const it_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagni`)
};

const ru_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ванные`)
};

const pt_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banheiros`)
};

const ko_field_bathrooms = /** @type {(inputs: Field_BathroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`욕실`)
};

/**
* | output |
* | --- |
* | "Bathrooms" |
*
* @param {Field_BathroomsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_bathrooms = /** @type {((inputs?: Field_BathroomsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_BathroomsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_bathrooms(inputs)
	if (locale === "es") return es_field_bathrooms(inputs)
	if (locale === "fr") return fr_field_bathrooms(inputs)
	if (locale === "de") return de_field_bathrooms(inputs)
	if (locale === "ja") return ja_field_bathrooms(inputs)
	if (locale === "zh") return zh_field_bathrooms(inputs)
	if (locale === "ar") return ar_field_bathrooms(inputs)
	if (locale === "id") return id_field_bathrooms(inputs)
	if (locale === "it") return it_field_bathrooms(inputs)
	if (locale === "ru") return ru_field_bathrooms(inputs)
	if (locale === "pt") return pt_field_bathrooms(inputs)
	return ko_field_bathrooms(inputs)
});